import { Box, styled } from '@mui/material';

export const StyledImage = styled('img')({
  display: 'block',
  width: '90px',
  height: '90px',
  objectFit: 'contain',
});

export const ImagePreviewContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
});

export const FileNameDisplay = styled('span')(({ theme }) => ({
  maxWidth: '100px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: theme.typography.textXs.fontSize,
  color: theme.palette.primary.main,
}));
